import type { GPTGameNameType, GPTGameObjectType } from '../types';

export const GAME_ORIGIN = window.origin.includes('localhost')
  ? import.meta.env.VITE_DOMAIN
  : window.origin;

export const GPT_GAME_MODAL_BG = 'rgba(0, 0, 0, 0.8)';

export const GAMES_CONFIG = {
  dailyBonus: {
    name: 'dailyBonus',
    path: '/gpt/easydailybonus/index.html',
    orientation: 'portrait',
    authOnly: true,
    statusUrl: '/gpt/daily-bonus/public/api/v1/user/state',
    statusUrlNonAuth: '/gpt/daily-bonus/public/non-auth/api/v1/feature/state'
  },
  cardGame: {
    name: 'cardGame',
    path: '/gpt/easycards/index.html',
    orientation: 'universal-landscape',
    authOnly: true,
    statusUrl: '/gpt/lucky-card/public/api/v1/feature/state',
    statusUrlNonAuth: '/gpt/lucky-card/public/api/v1/feature/state'
  },
  wheelOfFortune: {
    name: 'wheelOfFortune',
    path: '/gpt/easywheeloffortune/index.html',
    orientation: 'portrait',
    authOnly: true,
    statusUrl: '/gpt/wheel-of-fortune/public/api/v1/feature/state',
    statusUrlNonAuth: '/gpt/wheel-of-fortune/public/api/v1/feature/state'
  },
  birdGame: {
    name: 'birdGame',
    path: '/gpt/easypigeon/index.html',
    orientation: 'portrait',
    authOnly: false,
    statusUrl: '/gpt/jet-bird/public/api/v1/feature/state',
    statusUrlNonAuth: '/gpt/jet-bird/public/api/v1/feature/state'
  },
  oneReelSlot: {
    name: 'oneReelSlot',
    path: '/gpt/easyonereelslot/index.html',
    orientation: 'universal-landscape',
    authOnly: false,
    statusUrl: '',
    statusUrlNonAuth: ''
  },
  vendingMachine: {
    name: 'vendingMachine',
    path: '/gpt/easyvendingmachine/index.html',
    orientation: 'portrait',
    palette: undefined,
    authOnly: false,
    statusUrl: '/gpt/vending-machine/public/api/v1/feature/state',
    statusUrlNonAuth: '/gpt/vending-machine/public/api/v1/feature/state'
  }
} as const satisfies Record<GPTGameNameType, GPTGameObjectType>;
